import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as libraryActions from '~/library/actions';
import * as navActions from '~/sidebarNav/actions';
import LibraryView from '~/library/containers/LibraryView';
import LibraryViewHeader from '~/library/containers/LibraryViewHeader';
import SourceClearSpinner from '~/containers/SourceClearSpinner';
import Helmet from 'react-helmet';
import MetadataService from '~/utils/MetadataService';
import StringService from '~/utils/StringService';
import Helpers from '~/utils/Helpers';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import PermissionsHelper from '~/utils/PermissionsHelper';
import CvssService from '~/utils/CvssService';
import ArtifactViewMainContentCopyright from '~/artifact/components/ArtifactViewMainContentCopyright';
import GenericCallToAction from '~/containers/GenericViewPaywall/genericCTAWithNoEmailInput';
type LibraryPageProps = {
  params: object;
  actions: object;
  libraryState: object;
  myState: object;
  orgState: object;
  location: object;
  vcPageState: object;
};
class LibraryPage extends React.Component<LibraryPageProps, {}> {
  constructor(props, context) {
    super(props, context);
  }
  componentDidMount() {
    this.props.actions.maybeLoadComponent(this.props.params.componentId);
    this.props.actions.loadUrlAndParams(
      this.props.params,
      `/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/libraries`
    );
    if (CvssService.isCvss2Selected()) {
      //Check if cookie state is set to cvss2, if yes, set library view to show cvss2
      this.updateCvssSelection('cvss2');
    } else {
      this.updateCvssSelection('cvss3');
    }
    window.scrollTo(0, 0);
  }
  UNSAFE_componentWillUpdate(nextProps) {
    //Redirect /${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/libraries/:componentId to /${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/libraries/:title/:language/:packageManager/lid-:componentId
    const { libraryState } = nextProps;
    const { component = {} } = libraryState;
    const { libraryModel = {} } = component;
    if (libraryModel.id) {
      const pathname = this.props.location.pathname,
        baseUrl = `/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/libraries`;
      if (!pathname.includes('lid-')) {
        //If URI does not include the lid- which appears on standard URLs, build a complete URI
        const title = libraryModel.name ? libraryModel.name : libraryModel.description;
        let sanitizedTitle = StringService.sanitizeTitle(libraryModel.name);
        let expectedPath =
          baseUrl +
          '/' +
          sanitizedTitle +
          '/' +
          libraryModel.languageType +
          '/' +
          libraryModel.coordinateType +
          '/lid-' +
          libraryModel.id; //StringService.createSEOComponentItemUrl(title, libraryModel.languageType, libraryModel.id, libraryModel.coordinateType);
        const { query = {} } = this.props.location;
        const { version = '', commit_hash = '' } = query;
        if (version) {
          expectedPath = `${expectedPath}/versions/${version}`;
        } else if (
          Helpers.isCommitHashSupportedByLanguage(libraryModel.languageType) &&
          commit_hash
        ) {
          expectedPath = `${expectedPath}/commit_hash/${commit_hash}`;
        }
        this.props.actions.loadUrlAndParams(
          {
            title,
            language: libraryModel.languageType,
            componentId: libraryModel.id,
            packageManager: libraryModel.coordinateType,
          },
          baseUrl
        );
        browserHistory.replace(expectedPath);
      }
    }
  }
  updateCvssSelection(cvss) {
    this.props.actions.updateLibraryCvssSelection(cvss);
  }
  render() {
    const {
      myState,
      orgState,
      libraryState,
      params,
      vcPageState: { shouldShowVeracodePage },
    } = this.props;
    const { component = {}, cvss } = libraryState;
    const { libraryModel = {} } = component;
    const { name: componentName = '' } = libraryModel;
    if (!componentName) {
      return <SourceClearSpinner />;
    }
    const meta = MetadataService.generateComponentMeta(component, window.location.href);
    const isLoggedInAndPaidOrTrialing = PermissionsHelper.isLoggedInAndPaidOrTrialing(
      myState,
      orgState
    );
    const showPaywallCTA = !isLoggedInAndPaidOrTrialing;
    return (
      <div>
        <Helmet
          title={`Vulnerabilities found in the ${Helpers.sanitizeLanguageType(
            params.language
          )} - ${componentName} library`}
          meta={meta}
        />
        {CvssService.isCvss3Enabled() && (
          <div>
            {cvss === 'cvss2' ? (
              <div className="grid__item col-1-1 pl- pt-- mt-">
                Vulnerability data is based on CVSS version 2 scores.{' '}
                <span className="link--primary" onClick={() => this.updateCvssSelection('cvss3')}>
                  Click to see results based on CVSS version 3.
                </span>
              </div>
            ) : (
              <div className="grid__item col-1-1 pl- pt-- mt-">
                Vulnerability data is based on CVSS version 3 scores.{' '}
                <span className="link--primary" onClick={() => this.updateCvssSelection('cvss2')}>
                  Click to see results based on CVSS version 2.
                </span>
              </div>
            )}
          </div>
        )}
        <LibraryViewHeader />

        {showPaywallCTA ? (
          <div className="mt">
            <GenericCallToAction />
          </div>
        ) : (
          <LibraryView params={params} />
        )}
        {!shouldShowVeracodePage && <ArtifactViewMainContentCopyright />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
    myState: state.myState,
    orgState: state.orgState,
    vcPageState: state.vcPageState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, libraryActions, navActions), dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryPage);
